// Create a configuration file
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_URL,
  websocketUrl: import.meta.env.VITE_API_WEB_SOCKET_URL,
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  mode: import.meta.env.VITE_MODE,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};
